import { yupResolver } from '@hookform/resolvers/yup'
import PropTypes from 'prop-types'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import SidePopover from '@/components/side-popover/SidePopover.jsx'
import BillingForm from '@/pages/projects/detail/detail-standard-projects/project-form/billing-form/BillingForm.jsx'
import {
    DEFAULT_BILLING_PROJECTS_MOCK,
    validationSchema,
} from '@/pages/projects/detail/detail-standard-projects/project-form/billing-form/billingForm.schema.js'

const BillingFormWrapper = ({
    dataForm,
    closeModal,
    openDialogDelete,
    isEdit,
    sals,
    isFinance,
}) => {
    const { t } = useTranslation()

    const methods = useForm({
        shouldUnregister: false,
        mode: 'all',
        reValidateMode: 'onChange',
        nativeValidation: false,
        shouldFocusError: true,
        resolver: yupResolver(validationSchema),
        defaultValues: DEFAULT_BILLING_PROJECTS_MOCK,
    })

    const {
        formState: { isDirty },
    } = methods

    return (
        <FormProvider {...methods}>
            <SidePopover
                onClose={() => closeModal(isDirty)}
                isDirty={isDirty}
                title={
                    isEdit
                        ? t(`billing_project.edit_title`)
                        : t(`billing_project.create_title`)
                }
            >
                <BillingForm
                    isEdit={isEdit}
                    closeModal={closeModal}
                    dataForm={dataForm}
                    openDialogDelete={openDialogDelete}
                    sals={sals}
                    isFinance={isFinance}
                />
            </SidePopover>
        </FormProvider>
    )
}

export default BillingFormWrapper

BillingFormWrapper.propTypes = {
    dataForm: PropTypes.object,
    onClose: PropTypes.func,
    closeModal: PropTypes.func,
    openDialogDelete: PropTypes.func,
    isEdit: PropTypes.bool,
    sals: PropTypes.array,
    isFinance: PropTypes.bool,
}
